import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["tagId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { tagsRoutes } from './routes';
export class Tags {
  constructor() {
    _defineProperty(this, "routes", tagsRoutes);
  }
  async createTag(data, options) {
    const resp = await requestService('property').post(this.routes.baseUrl, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getAllTags(options) {
    const resp = await requestService('property').get(this.routes.baseUrl, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateTag(data, options) {
    const tagId = data.tagId,
      rest = _objectWithoutProperties(data, _excluded);
    const resp = await requestService('property').put(this.routes.tagsById(tagId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deleteTag(data, options) {
    const tagId = data.tagId;
    const resp = await requestService('property').delete(this.routes.tagsById(tagId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getTagById(data, options) {
    const tagId = data.tagId;
    const resp = await requestService('property').get(this.routes.tagsById(tagId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getAllTagsByAccountIds(data, options) {
    const resp = await requestService('property').post(this.routes.bulkGet, _objectSpread({}, data.data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async removeTagsFromAccount(data, options) {
    const companyId = data.companyId,
      idx = data.idx;
    const resp = await requestService('property').post(this.routes.removeTagsFromAccount(companyId), idx, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async assignTagsToAccount(data, options) {
    const companyId = data.companyId,
      idx = data.idx;
    const resp = await requestService('property').put(this.routes.assignTagsToAccount(companyId), idx, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}